export default __webpack_public_path__ + "assets/models/1c3126773424d0de51cdfb37b07d78b5.glb";